import React, { Component } from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import config from '../../config/SiteConfig.js';
import getUserData from '../../utils/getUserData';
import log from '../../utils/log';
import EOk from '../Emoji/EOk';

export default class BuyBtn extends Component {
	constructor(props) {
		super(props);

		this.openCheckout = this.openCheckout.bind(this);
	}

	async openCheckout() {
		// Get user data.
		const userData = await getUserData();

		// Is Debug logging on?
		const isLog = this.props.log;

		isLog && log('userData', userData);

		// Add do and course to the userData.
		const passthroughData = {
			do: 'customer',
			ip: userData.ip && userData.ip,
			affiliateId: window.affiliateID ? window.affiliateID : undefined,
			utmSource: window.utm_source ? window.utm_source : undefined,
			utmMedium: window.utm_medium ? window.utm_medium : undefined,
			utmCampaign: window.utm_campaign ? window.utm_campaign : undefined,
			referrer: document.referrer ? document.referrer : undefined,
			ref: window.ref ? window.ref : undefined,
			tag: config.tag ? config.tag : undefined,
		};

		// Log or not?
		isLog && log('passthroughData', passthroughData);

		// isUpSell?
		const isUpSell = this.props.productId === 544744;

		// Get Paddle.
		const Paddle = window.Paddle;

		Paddle.Checkout.open({
			product: this.props.productId,
			passthrough: passthroughData,
			marketingConsent: true,
			is_recoverable: false,
			upsell: isUpSell && 544745,
			upsellTitle: isUpSell && '🌟 Upgrade to Master Package!',
			upsellText:
				isUpSell &&
				"The VSCode.pro Master class is the <strong>recommended package</strong> for all the reasons listed below. <br />→ You get five more modules<br />→ All <strong>extensions</strong> setup that I use<br />→ Pro <strong>Markdown & GitHub</strong> tips <br />→ <strong>Git + Open Source</strong> workflows<br />→ Learn how to start <strong>debugging</strong><br />→ Setup <strong>JavaScript & PHP</strong><br />→ IDE setup <strong>Go/Python/ROR</strong> code <br />→ Easy <strong>auto-formatting setup</strong><br />→ Setup ESLint/Prettier</strong> for JavaScript <br />→ <strong>Auto-format PHP</strong>, yes!<br />→ Setup <strong>phpcs + phpcbf</strong><br />→ All for an extra lunch money!<br />→ More bang for your buck</strong><br />→ C'mon save 100s of hours!",
			upsellAction: isUpSell && 'Upgrade to Master Package!',
		});
	}

	render() {
		return (
			<Wrap>
				<Button {...this.props} onClick={this.openCheckout}>
					{this.props.buyText}
					<Price>
						<strike>${this.props.regular_price}</strike>
						<span>${this.props.price}</span>
					</Price>
				</Button>
				<EOk width="36" height="36" />
			</Wrap>
		);
	}
}

// Styles.
const Wrap = styled.div`
	position: relative;
	margin: 0 auto;

	${rmq('ml')} {
		max-width: 40rem;
	}
	${rmq('ms')} {
		max-width: 25rem;
	}

	img {
		visibility: hidden;
		opacity: 0;
		position: absolute;
		top: -3rem;
		right: 5rem;
		margin: 0 1rem;
		transform: rotateZ(-25deg);

		${rmq('ls')} {
			right: 4rem;
		}
		${rmq('t')} {
			right: 5rem;
		}
		${rmq('ml')} {
			right: 1rem;
		}
	}

	&:hover img {
		display: inline-block;
		transform: scale(1.5);
		transition: all 0.4s ease;
		visibility: visible;
		opacity: 1;
	}
`;

const Button = styled.a`
	display: table;
	width: 100%;
	min-width: 40rem;
	max-width: 40rem;
	margin: 5rem auto;
	padding: 1.6rem;
	background: ${(props) => (props.green ? props.theme.grgreen3 : props.theme.grgray1)};
	box-shadow: ${(props) => (props.green ? `rgba(148, 209, 79, 0.3)` : `rgba(144, 145, 157, 0.5)`)} 0rem 1rem 2rem;
	position: relative;
	text-align: center;
	font-family: ${(props) => props.theme.f2};
	font-size: 2rem;
	font-weight: 900;
	cursor: pointer;
	color: white;
	border-radius: 500rem;
	text-decoration: none;
	transition: box-shadow 0.8s cubic-bezier(0.2, 0.8, 0.2, 1.2) 0s, transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1.2) 0s;
	transition: all 0.4s ease;

	${rmq('470')} {
		margin: 3rem auto;
		min-width: 25rem;
		padding: 1.6rem;
		font-size: 1.8rem;
	}

	${rmq('ms')} {
		min-width: unset;
		padding: 1rem;
	}

	${rmq('250')} {
		border-radius: 1rem;
		font-size: 1.6rem;
	}
	&:hover {
		transition: all 0.4s ease;
		box-shadow: ${(props) => (props.green ? `rgba(148, 209, 79, 0.5)` : `rgba(144, 145, 157, 0.7)`)} 0rem 1rem 2rem;
	}
`;

const Price = styled.span`
	border-left: 1px solid #ffd000;
	padding-left: 1.5rem;
	margin-left: 1.5rem;

	strike {
		color: ${(props) => props.theme.gray1};
		margin-right: 0.6rem;
	}
`;
